/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'

export default class Sidebar extends Component {
    render() {
        return (
            <div>
                <div>
                    <a href="#" className="js-colorlib-nav-toggle colorlib-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i /></a>
                    <aside id="colorlib-aside" role="complementary" className="border js-fullheight">
                        <div className="text-center">
                            <div className="author-img" style={{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/portfolio-aceb7.appspot.com/o/public%2Fimages%2Fpic.JPG?alt=media&token=39aff6b9-9d42-4e67-a49f-9d69b89e8924)' }} />
                            <h1 id="colorlib-logo"><a href="index.html">Nduka Joshua</a></h1>
                            <span className="email"><i className="icon-mail"></i> jbamisere@gamil.com</span>
                            <span className="number"><i className="icon-phone"></i> +2348136065038</span>
                        </div>
                        <nav id="colorlib-main-menu" role="navigation" className="navbar">
                            <div id="navbar" className="collapse">
                                <ul>

                                    <li><a href="#" data-nav-section="about">About</a></li>
                                    <li className="active"><a href="#" data-nav-section="home">Introduction</a></li>
                                    <li><a href="#" data-nav-section="timeline">Timeline</a></li>
                                </ul>
                            </div>
                        </nav>
                        <nav id="colorlib-main-menu">
                            <ul>
                                <li><a href="https://www.facebook.com/nduka.joshua" target="_blank"><i className="icon-facebook2" /></a></li>
                                <li><a href="https://twitter.com/jbamisere" target="_blank"><i className="icon-twitter2" /></a></li>
                                <li><a href="https://www.instagram.com/jbamisere/" target="_blank"><i className="icon-instagram" /></a></li>
                                <li><a href="https://www.linkedin.com/in/joshua-bamisere-735b38125/" target="_blank"><i className="icon-linkedin2" /></a></li>
                                <li><a href="https://github.com/bamisere" target="_blank"><i className="icon-github"></i></a></li>

                            </ul>
                        </nav>

                    </aside>
                </div>
            </div>
        )
    }
}
